import { AppSettingActions } from './../store/app-settings.reducer';
import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { IState } from '../store/root.reducer';
import { ICryptoRequest } from 'src/app/shared/domain/requests/crypto.request.entity';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { forkJoin, Observable } from 'rxjs';

export class AppSettingEntities {
  public static CONTACT = 'contact';
  public static SUPPLIER = 'supplier';
  public static SHOP = 'shop';
}

@Injectable()
export class AppSettingsService {

  private appId = environment.appId;
  private settings: AppSetting[] = [];
  private readonly baseUrl = `${environment.commonAPI}app-settings`;

  constructor(private httpClient: HttpClient, private store: Store<IState>) {
  }

  Set(body: SaveAppSettingsRequest): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + '/set/v2', body);
  }

  Get(body: IAppSettingsRequest): Observable<AppSetting[]> {
    return this.httpClient.post<AppSetting[]>(this.baseUrl + '/settings/v2', body);
  }

  private getSettings(appId: number, entityType: string): Observable<AppSetting[]> {
    const params = this.getAppSettingsRequest(appId, entityType);
    return this.Get(params);
  }

  private getAppSettingsRequest(appId: number, entityType: string, settingKey?: string): IAppSettingsRequest {
    return {
      entityType: entityType,
      appId: appId,
      settingKey: settingKey ? settingKey : null,
      encrypted: true
    };
  }


  writeSetting(requests: SaveAppSetting[]): void {
    const settingRequest: SaveAppSettingsRequest = <SaveAppSettingsRequest>{};
    settingRequest.settings = [];
    settingRequest.encrypted = true;
    requests.map(setting => {
      if (setting.appId === null || setting.appId === undefined || setting.appId.toString() === '') {
        setting.appId = this.appId;
      }
      if (typeof setting.value === 'number') {
        setting.value = setting.value.toString();
      }
      settingRequest.settings.push(setting);
    });
    this.Set(settingRequest).subscribe(res => {
        if (res.result !== true) {
          return null;
        }
        this.reloadSettings();
        return res;
    });
  }

  reloadSettings(): Promise<any> {
    const promise = new Promise<void>(resolve => {
    this.store.dispatch({
      type: AppSettingActions.SET_IS_LOADED,
      payload: false
    });
      forkJoin([
        this.getSettings(this.appId, AppSettingEntities.CONTACT),
        this.getSettings(this.appId, AppSettingEntities.SUPPLIER)
      ]).subscribe(settings => {
        this.store.dispatch({
          type: AppSettingActions.SET_SETTINGS,
          payload: settings[0].concat(settings[1])
        });
        this.store.dispatch({
          type: AppSettingActions.SET_IS_LOADED,
          payload: true
        });
        resolve();
      });
    });
    return promise;
   }

  getSetting(key: string): AppSetting {
    this.store.pipe(select((store: IState) => store.appSettings.Settings)).subscribe(settings => {
      this.settings = settings;
    }).unsubscribe();

    const setting = this.settings.filter(s => s.key.toUpperCase() === key.toUpperCase());
    if (setting.length > 0) {
      return setting[0] as AppSetting;
    } else {
      return <AppSetting>{};
    }
  }
}

interface IAppSettingsRequest extends ICryptoRequest {
  entityType: string;
  appId: number;
  settingKey: string;
}

interface SaveAppSettingsRequest extends ICryptoRequest {
  settings: SaveAppSetting[];
}

export interface SaveAppSetting {
  entityType: string;
  appId?: number;
  key: string;
  value: string | number;
}

export interface AppSetting {
  key: string;
  value: string | number;
  appId?: number;
  name?: string;
  description?: string;
  internal?: boolean;
  lastUpdate?: string | object;
  featureCode?: string;
  categoryName?: string;
  categoryOrder?: number;
  options?: AppSettingOption[];
  dataType: string;
  entityType: string;
}
export interface AppSettingOption {
  settingKeyId: number;
  settingKey: string;
  settingOptionName: string;
  settingOptionValue: string | object;
  defaultValue: string;
}
